import { Eye } from 'lucide-react'
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@/components/ui/dialog"
import { Card, CardContent } from '@/components/ui/card'
import ProductImage from '@/components/layout/ProductImage'
import { Badge } from '@/components/ui/badge'
import { DatabaseZap } from 'lucide-react'
import AddToCart from './AddToCart'
import { Button } from '@/components/ui/button'
import { Separator } from '@/components/ui/separator'
import Link from 'next/link'
import { formatCurrency } from '@/utils/formatCurrency'

const ProductView = ({ product }) => {
  return (
    <Dialog>
      <DialogTrigger asChild>
        <Eye
          size={16}
          className="rounded text-brand-deep hover:text-brand-sky cursor-pointer transition-colors"
        />
      </DialogTrigger>
      <DialogContent className="sm:max-w-[600px] overflow-hidden rounded-2xl border-brand-light shadow-brand-lg">
        <DialogHeader>
          <DialogTitle className="capitalize text-brand-navy">
            {product?.title}
          </DialogTitle>
        </DialogHeader>
        <Separator className="bg-brand-light" />
        <Card className="border-none shadow-none">
          <CardContent className="flex gap-4 p-0">
            <div className='w-1/2 h-full'>
              <ProductImage product={product} />
            </div>
            <div className="max-w-sm">
              <h1 className="text-xl font-medium text-brand-navy">
                {product?.title}
              </h1>
              <p className="text-sm my-2 font-medium text-foreground">
                <span className="text-brand-deep mr-2 font-semibold">By:</span>
                {product?.author?.name}
              </p>
              <p className="text-sm font-medium capitalize text-foreground">
                <span className="text-brand-deep mr-2 font-semibold">Category:</span>
                {product?.category}
              </p>
              <div className="flex items-center my-6">
                {product?.discount === 0 ? (
                  <p className="text-base font-semibold text-brand-deep">
                    {formatCurrency(product?.price)}
                  </p>
                ) : (
                  <div className="flex items-center gap-4">
                    <div className='flex flex-col items-start'>
                      <p className="text-base font-semibold text-brand-deep">
                        {formatCurrency(Math.ceil(product?.discountedPrice))}
                      </p>
                      <p className="text-sm font-medium text-muted-foreground line-through">
                        {formatCurrency(product?.price)}
                      </p>
                    </div>
                    {product?.discount === 0 ? null :
                      <div className="flex gap-2 items-center">
                        <p className="text-sm text-brand-deep font-medium">
                          You save {formatCurrency(Math.ceil(product?.price) - Math.ceil(product?.discountedPrice))}
                        </p>
                        <Badge
                          variant="outline"
                          className="border-brand-sky text-brand-deep bg-brand-light/40"
                        >
                          {Math.ceil(product?.discount)}% off
                        </Badge>
                      </div>
                    }
                  </div>
                )}
              </div>
              <div>
                <div className="flex gap-2 items-center">
                  {product?.countInStock <= 0 && (
                    <>
                      <DatabaseZap size={14} color="#EA0303" />
                      <span className="font-medium text-destructive">Out of stock</span>
                    </>
                  )}
                  {product?.countInStock > 0 && (
                    <>
                      <DatabaseZap size={14} color="#039F00" />
                      <span className="font-medium text-custom-text-green">In Stock</span>
                    </>
                  )}
                  <Badge
                    variant="outline"
                    className="border-brand-light text-muted-foreground"
                  >
                    Code: {product?.barcode}
                  </Badge>
                </div>
              </div>
              <div className="w-full flex items-center gap-2 mt-4">
                <Link href={`/product/${(product?.slug)}`}>
                  <Button className='gradient-primary hover:opacity-95 h-full text-sm text-white w-full rounded-xl flex items-center gap-2 font-semibold shadow-brand transition-all'>
                    View Details
                  </Button>
                </Link>
                <AddToCart product={product} />
              </div>
            </div>
          </CardContent>
        </Card>
      </DialogContent>
    </Dialog>
  )
}

export default ProductView